<template>
    <div class="container">
        <div>
            <b-modal id="loading-modal"
                v-model="bookingIsLoading"
                centered
                size="sm"
                :hide-header="true"
                :hide-footer="true"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
                :hide-header-close="true" >
                <div class="modal-title" hidden="true"></div>

                <p class="d-flex justify-content-center">
                    Caricamento...
                </p>
                <p class="d-flex justify-content-center">
                    <hollow-dots-spinner
                        :animation-duration="1000"
                        :dot-size="15"
                        :dots-num="3"
                        color="#ff1d5e"
                        align="center"
                        />
                </p>
                <div class="modal-footer" hidden="true"></div>
            </b-modal>
        </div>

        <div class="row searchFilters pb-4" v-if="loadingFiltersData">
            <div class="col-lg-8">
                <div class="form-group">
                    <label class="loading-animation">&nbsp;</label>
                    <div class="loading-animation multiselect"></div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <label class="loading-animation">&nbsp;</label>
                    <div class="loading-animation multiselect"></div>
                </div>
            </div>
        </div>
        <div class="row searchFilters pb-4" v-else>
            <div class="col-lg-3" v-if="showHeadquarterSelect">
                <div class="form-group">
                    <label for="filter-headquarter">Sede</label>
                    <multiselect id="filter-headquarter"
                        v-model="filterHeadquarter"
                        v-on:input="onChangeHeadquarter"
                        :options="headquarterOptions"
                        :placeholder="'Seleziona una voce'"
                        :show-labels="false"
                        track-by="id"
                        label="name"
                        />
                </div>
            </div>

            <div class="col-lg col-ellipsis">
                <div class="form-group">
                    <label for="filter-multisearch">Cerca</label>
                    <!-- https://vue-multiselect.js.org/#sub-custom-option-template -->
                    <multiselect id="filter-multisearch"
                        v-model="filterMultiSearch"
                        v-on:input="onChangeGenericSearch"
                        :placeholder="dynamicPlaceholderText"
                        :options="multiSearchOptions"
                        :show-labels="false"
                        track-by="_option_id"
                        label="name"
                    >
                        <template slot="singleLabel" slot-scope="props">
                            <span class="option__desc">
                                <span class="option__icon">
                                    <i :class="props.option._icon_class" />
                                </span>
                                <span class="option__title">
                                    {{ props.option.name }}
                                </span>
                            </span>
                        </template>
                        <template slot="option" slot-scope="props">
                            <div class="option__desc">
                                <span class="option__icon">
                                    <i :class="props.option._icon_class" />
                                </span>
                                <span class="option__title">
                                    {{ props.option.name }}
                                </span>
                            </div>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <label for="filter-date">Data</label>
                    <div class="d-flex">
                        <div class="">
                            <button type="button" class="btn btn-outline-default" v-on:click="changeDateBackwardOneDay" :disabled="filterDate <= today">
                                <i class="fa fa-caret-left"></i>
                            </button>
                        </div>
                        <div class="flex-fill pl-2 pr-2">
                            <b-form-datepicker
                                v-model="filterDate"
                                v-on:input="onChangeDate"
                                :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }"
                                :min="today"
                                start-weekday="1"
                                :value-as-date="true"
                                label-help=""
                                locale="it"
                                />
                        </div>
                        <div class="">
                            <button type="button" class="btn btn-outline-default" v-on:click="changeDateForwardOneDay">
                                <i class="fa fa-caret-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col" v-if="loadingFiltersData">
                <div class="alert loading-animation">&nbsp;</div>
            </div>
            <div class="col col-auto mx-auto" v-else-if="loadingAvailabilities">
                <hollow-dots-spinner
                    :animation-duration="1000"
                    :dot-size="15"
                    :dots-num="3"
                    color="red"
                    align="center"
                    />
            </div>
            <div class="col" v-else-if="errorMessage">
                <div class="alert alert-warning text-center text-uppercase font-weight-bold">{{ errorMessage }}</div>
            </div>
            <div class="col" v-else-if="noResults">
                <div class="alert alert-warning text-center text-uppercase font-weight-bold">Nessun risultato trovato</div>
            </div>
            <div class="col" v-else>
                <resource-booking-box
                    v-for="(availability, index) in availabilities"
                    v-bind:key="index"
                    v-bind:filterDate="filterDate"
                    v-bind:filterType="getFilterMultiSearchType()"
                    v-bind:displayDaysRange="displayDaysRange"
                    v-bind:instanceId="instanceId"
                    v-bind:resource="availability.resource"
                    v-bind:service="availability.service"
                    v-bind:resourceServices="getResourceServices(availability.resource)"
                    v-bind:presences="availability.presences"
                    v-bind:firstDayPresence="availability.firstDayPresence"
                    v-on:getAvailability="getAvailability"
                    v-on:setLoadingBookingDialog="setLoadingBookingDialog"
                    v-on:setBookingPopupData="setBookingPopupData"
                    v-on:set-date="setDate"
                />
            </div>
        </div>
        <resource-booking-popup
            ref="resourceBookingPopup"
            v-bind:instanceId="instanceId"
            v-bind:countries="countries"
            v-bind:resource="selectedResource"
            v-bind:service="selectedService"
            v-bind:resourceServices="selectedResourceServices"
            v-bind:headquarter="selectedHeadquarter"
            v-bind:bookDateTime="selectedBookDateTime"
            v-bind:maxSlotDuration="selectedMaxSlotDuration"
            v-bind:user="user"
            v-on:setLoadingBookingDialog="setLoadingBookingDialog"
            v-on:setBookingPopupData="setBookingPopupData"
            v-on:setServiceById="setServiceById"
            v-on:openCheckoutDialog="openCheckoutDialog"
            v-on:getAvailability="getAvailability"
        />
        <resource-booking-checkout
            v-bind:stripeClientSecret="stripeClientSecret"
            v-bind:resource="selectedResource"
            v-bind:service="selectedService"
            v-bind:user="user"
            v-bind:checkoutNote="checkoutNote"
            v-on:closeCheckoutDialog="closeCheckoutDialog"
            v-on:setLoadingPaymentConfirm="setLoadingPaymentConfirm"
        />
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Multiselect from 'vue-multiselect';
import { HollowDotsSpinner } from 'epic-spinners';
import moment from 'moment';
import VueTypes from 'vue-types';

export default {
    components: {
        Multiselect,
        HollowDotsSpinner,
    },
    data() {
        return {
            today: new Date(),
            displayDaysRange: 5,
            searchDaysRange: 90,
            loadingFiltersData: false,
            loadingAvailabilities: false,
            loadingBookingDialog: false,
            loadingPaymentConfirm: false,
            stripeClientSecret: null,
            selectedResource: null,
            selectedHeadquarter: null,
            selectedService: null,
            selectedResourceServices: {},
            selectedMultiSearch: null,
            selectedBookDateTime: null,
            selectedMaxSlotDuration: null,
            errorMessage: false,
            noResults: false,
            filterHeadquarter: null,
            filterMultiSearch: null,
            filterDate: moment().toDate(),
            checkoutNote: null,
            countries: [],
            headquarters: {},
            services: {},
            serviceCategories: {},
            resources: {},
            headquarterOptions: [],
            multiSearchOptions: [],
            multiSearchFullOptions: [],
            availabilities: [],
            user: {
                first_name: '',
                middle_name: '',
                last_name: '',
                national_identification_number: '',
                vat_code: '',
                address: '',
                postal_code: '',
                country_code: '',
                area: '',
                city: '',
            },
            serverSettings: {
                enableSearchService: false,
                enableSearchServiceCategory: false,
                enableSearchResource: false,
            },
        };
    },
    props: {
        instanceId: VueTypes.number.def(undefined),
    },
    computed: {
        bookingIsLoading: function() {
            return this.loadingBookingDialog || this.loadingPaymentConfirm;
        },
        showHeadquarterSelect: function() {
            return this.headquarterOptions.length > 1;
        },
        dynamicPlaceholderText() {
            const parts = [];
            if (this.serverSettings.enableSearchService) {
                parts.push('Prestazioni');
            }
            if (this.serverSettings.enableSearchServiceCategory) {
                parts.push('Specialità');
            }
            if (this.serverSettings.enableSearchResource) {
                parts.push('Medici');
            }
            return `Cerca ${parts.join(', ')}`;
        }
    },
    mounted() {
        this.getSearchFiltersFromUrl();

        this.initSearchForm();
        this.getAvailability();

        window.addEventListener('popstate', () => {
            console.log('url changed');

            this.getSearchFiltersFromUrl();
            this.getAvailability();
        });
    },
    methods: {
        getSearchFiltersFromUrl() {
            var queryParams = this.$queryString.parse(location.search);
            if (queryParams.headquarter) {
                this.filterHeadquarter = {id: queryParams.headquarter, name: ''};
            }
            if (queryParams.service) {
                this.filterMultiSearch = {
                    _type: 'service',
                    id: queryParams.service,
                };
            }
            if (queryParams.service_category) {
                this.filterMultiSearch = {
                    _type: 'service_category',
                    id: queryParams.service_category,
                };
            }
            if (queryParams.resource) {
                this.filterMultiSearch = {
                    _type: 'resource',
                    id: queryParams.resource,
                };
            }
            if (this.filterMultiSearch) {
                this.filterMultiSearch._icon_class = 'fa fa-spinner-third fa-spin';
                this.filterMultiSearch.name = '';
            }

            if (queryParams.date) {
                this.filterDate = moment(queryParams.date, "YYYY-MM-DD").toDate();
            }
        },
        onChangeHeadquarter() {
            let headquarterId = this.filterHeadquarter ? this.filterHeadquarter.id : null;
            this.$queryString.push('headquarter', headquarterId);
            this.refreshMultiSearchOptions();

            this.getAvailability();
        },
        onChangeGenericSearch() {
            let searchType = this.filterMultiSearch ? this.filterMultiSearch._type : null;  // TODO: Funzionalizzare in quanto viene usato anche da altre parti
            let multiSearchId = this.filterMultiSearch ? this.filterMultiSearch.id : null;

            this.$queryString.remove('service');
            this.$queryString.remove('service_category');
            this.$queryString.remove('resource');

            switch (searchType) {
                case 'service':
                    this.$queryString.push('service', multiSearchId);
                    break;
                case 'service_category':
                    this.$queryString.push('service_category', multiSearchId);
                    break;
                case 'resource':
                    this.$queryString.push('resource', multiSearchId);
                    break;
                case null:
                    break;
                default:
                    this.$snotify.error("searchType unknown: "+searchType);
                    break;
            }

            this.getAvailability();
        },

        onChangeDate() {
            let filterDate = moment(this.filterDate, "DD/MM/YYYY").format("YYYY-MM-DD");
            this.$queryString.push('date', filterDate);

            this.getAvailability();
        },
        initSearchForm() {
            this.checkoutNote = null;
            this.countries = [];
            this.multiSearchOptions = [];
            this.multiSearchFullOptions = [];
            this.headquarterOptions = [];
            this.headquarters = {};
            this.services = {};
            this.serviceCategories = {};
            this.resources = {};
            this.user = {};
            this.serverSettings = {};

            this.loadingFiltersData = true;
            axiosOnce({
                    method: "get",
                    url: baseUrl+"/book-resource/get-data",
                    // crossDomain: true,
                    withCredentials: false,
                    params: {
                        'selectedHeadquarterId': (this.filterHeadquarter ? this.filterHeadquarter.id : null),
                        // 'selectedServiceId': (this.filterService ? this.filterService.id : null),
                        'selectedMultiSearchId': (this.filterMultiSearch ? this.filterMultiSearch.id : null),
                        'selectedMultiSearchType': (this.filterMultiSearch ? this.filterMultiSearch._type : null),
                    }
                }, 'getData')
                .then(({ data }) => {
                    this.serverSettings = data.serverSettings;

                    this.checkoutNote = data.checkoutNote;
                    if (this.filterHeadquarter && this.filterHeadquarter.id && this.filterHeadquarter.name == '') {
                        this.filterHeadquarter = data.selectedHeadquarter;
                    }
                    if (this.filterMultiSearch && this.filterMultiSearch.id && this.filterMultiSearch.name == '') {
                        this.filterMultiSearch = data.selectedMultiSearch
                        this.filterMultiSearch._option_id = this.getOptionId(this.filterMultiSearch);
                        this.filterMultiSearch._icon_class = this.getIconClassByMultiSearchType(this.filterMultiSearch._type);
                    }
                    data.countries.forEach(country => {
                        this.countries.push(country);
                    });
                    data.headquarters.forEach(headquarter => {
                        this.headquarterOptions.push(headquarter);
                        this.headquarters[headquarter['id']] = headquarter;
                    });
                    data.services.forEach(service => {
                        this.services[service['id']] = service;     // TODO: Trasformato in oggetto come per gli headquarters in modo che si possa facilmente referenziare usando l'ID, per ora non viene usato da nessuna parte

                        if (this.serverSettings['enableSearchService'] ?? false) {
                            service['_type'] = 'service';
                            service['_option_id'] = this.getOptionId(service);
                            service['_icon_class'] = this.getIconClassByMultiSearchType(service['_type']);
                            this.multiSearchFullOptions.push(service);
                        }
                    });
                    data.serviceCategories.forEach(serviceCategory => {
                        this.serviceCategories[serviceCategory['id']] = serviceCategory;

                        if (this.serverSettings['enableSearchServiceCategory'] ?? false) {
                            serviceCategory['_type'] = 'service_category';
                            serviceCategory['_option_id'] = this.getOptionId(serviceCategory);
                            serviceCategory['_icon_class'] = this.getIconClassByMultiSearchType(serviceCategory['_type']);
                            this.multiSearchFullOptions.push(serviceCategory);
                        }
                    });
                    data.resources.forEach(resource => {
                        this.resources[resource['id']] = resource;

                        if (this.serverSettings['enableSearchResource'] ?? false) {
                            resource['_type'] = 'resource';
                            resource['_option_id'] = this.getOptionId(resource);
                            resource['_icon_class'] = this.getIconClassByMultiSearchType(resource['_type']);
                            resource['_services'] = []; // TODO: Verificare se ha senso questo services con _ o fa solo casino
                            resource.services.forEach(serviceId => {
                                let service = this.services[serviceId];
                                if (service) {
                                    resource['_services'].push({
                                        'id': service['id'],
                                        'name': service['name'],
                                        'duration': service['duration'],
                                        'price': service['price'],
                                        'bookingPrice': service['bookingPrice'],
                                        'vatRate': service['vatRate'],
                                        'description': service['description'],
                                        'additionalInfo': service['additionalInfo'],
                                    });
                                }
                            });

                            this.multiSearchFullOptions.push(resource);
                        }
                    });
                    this.refreshMultiSearchOptions();

                    let user = {};
                    if (data.user) {
                        user = data.user;
                    }
                    this.user = user;

                    this.loadingFiltersData = false;
                })
                .catch(error => {
                    this.loadingFiltersData = false;

                    if (axios.isCancel(error)) {
                        console.log('Request canceled', error.message);
                        return;
                    } else if (error.code === 'ECONNABORTED') {
                        return;
                    }
                    let errorMessage = this.$t("error.connection_fail_during_parameter_fetching");
                    if (error.response) {
                        if (error.response.data.reason) {
                            errorMessage = error.response.data.reason;
                        } else if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        }
                    } else if (error) {
                        errorMessage = error;
                    }
                    this.$snotify.error(errorMessage);
                });
        },
        refreshMultiSearchOptions() {
            this.multiSearchOptions = [];
            this.multiSearchFullOptions.forEach(option => {
                // Se la sede è selezionata, filtra le opzioni che non sono associate a quella sede
                if (this.filterHeadquarter && this.filterHeadquarter.id && option.headquarter_ids && option.headquarter_ids.length && !option.headquarter_ids.includes(this.filterHeadquarter.id)) {
                    return;
                }
                this.multiSearchOptions.push(option);
            });
            if (this.filterMultiSearch && this.filterMultiSearch.id &&
                this.filterMultiSearch._type &&
                !this.multiSearchOptions.find(option => option.id == this.filterMultiSearch.id && option._type == this.filterMultiSearch._type)) {
                if (this.filterMultiSearch._type == 'service') {
                    this.$queryString.remove('service');
                } else if (this.filterMultiSearch._type == 'resource') {
                    this.$queryString.remove('resource');
                } else if (this.filterMultiSearch._type == 'service_category') {
                    this.$queryString.remove('service_category');
                }
                this.filterMultiSearch = null;
            }
        },
        getFilterMultiSearchType() {
            return this.filterMultiSearch ? this.filterMultiSearch._type : null;
        },
        getResourceServices(resource) {
            let services = {};
            if (resource && resource.id) {
                if (!this.resources[resource.id]) {
                    alert("Prestazioni del medico " + resource.name + " non trovate");
                    return services;
                }
                for (let i = 0; i < this.resources[resource.id].services.length; i++) {
                    let service = this.resources[resource.id].services[i];
                    services[service.id] = service;
                }
            }

            return services;
        },
        getAvailability() {
            this.availabilities = [];
            // if (!this.filterHeadquarter) {
            //     this.errorMessage = "Selezionare una sede";
            //     return;
            // }
            if (!this.filterMultiSearch) {
                this.errorMessage = this.$t('error.missing_search_parameters');
                return;
            }
            let filterDate = moment(this.filterDate, "DD/MM/YYYY").format("YYYY-MM-DD");
            let headquarterIds = this.filterHeadquarter ? [this.filterHeadquarter.id] : null;

            let searchType = this.filterMultiSearch?._type ?? null;
            let searchId = this.filterMultiSearch?.id ?? null;
            this.loadingAvailabilities = true;
            this.errorMessage = false;
            this.noResults = true;
            axiosOnce({
                    method: "get",
                    url: baseUrl+"/book-resource/get-availability",
                    // crossDomain: true,
                    withCredentials: false,
                    params: {
                        date: filterDate,
                        headquarter_ids: headquarterIds,
                        search_type: searchType,
                        search_id: searchId,
                        days: this.displayDaysRange,
                        days_next_availability: this.searchDaysRange,
                    }
                }, 'getAvailability')
                .then(({ data }) => {
                    // TODO: Controllare perchè non viene tirato un errore nel caso in cui venga ritornato errore 400 campo non valido
                    if (typeof data != "object") {
                        throw "Errore di comunicazione con il server";
                    }
                    data.forEach(availability => {
                        this.availabilities.push(availability);
                        // console.log(_.get(availability, "resource.name"));
                    });
                    if (this.availabilities.length) {
                        this.noResults = false;
                    }
                    this.loadingAvailabilities = false;
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        console.log('Request canceled', error.message);
                        return;
                    } else if (error.code === 'ECONNABORTED') {
                        this.loadingAvailabilities = false;
                        return;
                    }

                    let errorMessage = "Errore di connessione durante la lettura delle disponibilità";  // TODO: Spostare in traduzioni
                    if (error.response) {
                        if (error.response.data.errors) {
                            errorMessage = "";
                            for (let fieldName in error.response.data.errors) {
                                let fieldError = error.response.data.errors[fieldName];
                                errorMessage+= fieldError.join("\n") + "\n";
                            }
                        } else {
                            errorMessage = error.response.data.message;
                        }
                    } else if (error) {
                        errorMessage = error;
                    }
                    this.errorMessage = errorMessage;
                    this.$snotify.error(errorMessage);
                    this.loadingAvailabilities = false;
                });
        },
        setLoadingBookingDialog(status) {
            console.log("setLoadingBookingDialog");
            console.log(status);
            this.loadingBookingDialog = status;
        },
        setLoadingPaymentConfirm(status) {
            console.log("setLoadingPaymentConfirm");
            console.log(status);
            this.loadingPaymentConfirm = status;
        },
        setBookingPopupData(data) {
            console.log("setBookingPopupData");
            console.log(data);
            let thisComponent = this;

            if (data) {
                if (!this.user.id) {
                    this.$bvModal
                        .msgBoxConfirm("Per prenotare devi prima accedere alla piattaforma, vuoi procedere?", {  // TODO: Spostare in traduzioni
                            // title: 'Accesso richiesto',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'primary',
                            okTitle: 'SI',
                            cancelTitle: 'NO',
                            footerClass: 'p-2',
                            cancelVariant: 'default',
                            hideHeaderClose: false,
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                // FIXME: Verificare, forse si può fare il redirect direttamente
                                // window.location.href = "/book-resource/redirect-to-login";
                                window.location.href = "/login";

                                /*
                                // TODO: I parametri sono inutili in quanto non vengono usati, è sufficiente fare la chiamata alla pagina per fargli ricordare la pagina corrente prima del login
                                axiosOnce({
                                    method: "post",
                                    url: baseUrl+"/book-resource/redirect-to-login",
                                    searchData: {
                                        // filterHeadquarter: this.filterHeadquarter,
                                        // filterMultiSearch: this.filterMultiSearch,
                                        // filterDate: this.filterDate,
                                    }
                                }, 'redirectToLogin')
                                .then(function (response) {
                                    window.location.href = "/login";
                                })
                                .catch(function (error) {
                                    if (error.code === 'ECONNABORTED') {
                                        return;
                                    }

                                    var errorMessage;
                                    if (error && error.response) {
                                        errorMessage = error.response.data.message;
                                    } else {
                                        errorMessage = error.message;
                                    }

                                    // Durata dinamica del popup
                                    var dynamicTimeout = 6000;
                                    let textWords = errorMessage.split(' ').length;
                                    dynamicTimeout = Math.max(dynamicTimeout, textWords * 250);

                                    thisComponent.$snotify.error(errorMessage, {
                                        timeout: dynamicTimeout,
                                    });
                                });
                                */
                            }
                            this.boxOne = value;
                        })
                        .catch(error => {
                            if (error && error.response) {
                                thisComponent.$snotify.error(error.response.data.message);
                            } else {
                                thisComponent.$snotify.error(error.message);
                            }
                        });
                    return;
                }
                if (!this.user.has_verified_email) {
                    this.$bvModal
                        .msgBoxConfirm("Per prenotare devi prima verificare la tua mail, vuoi procedere?", {  // TODO: Spostare in traduzioni
                            // title: 'Mail non verificata',
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'primary',
                            okTitle: 'SI',
                            cancelTitle: 'NO',
                            cancelVariant: 'default',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                window.location.href = "/profile";
                            }
                        })
                        .catch(error => {
                            if (error && error.response) {
                                thisComponent.$snotify.error(error.response.data.message);
                            } else {
                                thisComponent.$snotify.error(error.message);
                            }
                        });
                    return;
                }

                let headquarter = this.headquarters[data.headquarter_id];
                data.headquarter.name = headquarter.name;

                this.selectedResource = data.resource;
                this.selectedService = data.service;
                this.selectedResourceServices = data.resourceServices;
                this.selectedMultiSearch = data.selectedMultiSearch;
                this.selectedHeadquarter = (typeof this.headquarters[data.headquarter_id] != "undefined" ? this.headquarters[data.headquarter_id] : null);
                this.selectedBookDateTime = data.book_date_time;
                this.selectedMaxSlotDuration = data.max_slot_duration;
            } else {
                this.selectedResource = null;
                this.selectedService = null;
                this.selectedResourceServices = {};
                this.selectedMultiSearch = null;
                this.selectedHeadquarter = null;
                this.selectedBookDateTime = null;
                this.selectedMaxSlotDuration = null;
            }
            // this.setLoadingBookingDialog(true);
        },
        setServiceById(serviceId) {
            this.selectedService = this.selectedResourceServices[serviceId] ?? null;

            // this.$refs.resourceBookingPopup.scrollToEndOfForm(); // Disabilitato scroll al bottom in quanto non serve più con questo rework dell'UI
        },
        setDate(date) {
            this.filterDate = date;
            this.onChangeDate();
        },
        changeDateForwardOneDay() {
            this.setDate(moment(this.filterDate).add(1, 'days').toDate());
        },
        changeDateBackwardOneDay() {
            this.setDate(moment(this.filterDate).subtract(1, 'days').toDate());
        },
        openCheckoutDialog(stripeClientSecret) {
            console.log("openCheckoutDialog");
            console.log(stripeClientSecret);
            this.stripeClientSecret = stripeClientSecret;
        },
        closeCheckoutDialog() {
            this.stripeClientSecret = null;
            this.setLoadingBookingDialog(false);
            this.getAvailability();
        },
        getIconClassByMultiSearchType(type) {
            let iconClass = null;
            switch (type) {
                case "service":
                    iconClass = "fa fa-stethoscope";
                    break;
                case "service_category":
                    iconClass = "fa fa-notes-medical";
                    break;
                case "resource":
                    iconClass = "fa fa-user-md";
                    break;
            }
            return iconClass;
        },
        getOptionId(option) {
            return option._type + "_" + option.id;
        },
    },
    filters: {
        properCase(string) {
            if (typeof string == "string") {
                return string.charAt(0).toUpperCase() + string.slice(1);
            } else {
                return "";
            }
        },
    },
};
</script>

<style lang="scss">
.card-image img {
    max-height: 160px;
}

.searchFilters .btn {
    width: 40px;
    height: 40px;
    padding: 0;

}

.loading-animation {
    overflow: hidden;

    &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #ccc;
        z-index: 1;
    }

    &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        transform: translateX(-100px);
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
        animation: loadingField 0.8s infinite;
        z-index: 1;
    }
}

label.loading-animation::before {
    height: 22px;
    max-width: 120px;
}

@keyframes loadingField {
    100% {
        transform: translateX(100%);
    }
}
</style>
